import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteTopics from '../../../SatelliteTopics/SatelliteTopics';
import satelliteIcon from '../../../satelliteIcon';

const InternalVsExternalSupport4 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="internalVsExternalSupport" section="external">
        <div className='TextGroup Satellite'>
            <SatelliteTopics t={props.t} prefix="internalVsExternalSupport:external.advantages" />
            <SatelliteTopics t={props.t} prefix="internalVsExternalSupport:external.challenges" noPadBottom />
        </div>
    </ServiceSection>
);

export default InternalVsExternalSupport4;
